import { Button as DSButton } from '@unmind/design-system';
import {
  LoggedOutScreenTitle,
  LoggedOutScreenSubtitle,
} from 'LoggedOut/LoggedOutScreenWrapper';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled(LoggedOutScreenTitle)`
  align-self: center;
`;

export const Description = styled(LoggedOutScreenSubtitle)`
  text-align: center;
`;

export const Button = styled(DSButton)`
  width: 100%;
`;
